import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/promotions/prizewheelBoard.png")